import type { ModeratorText } from '@blind-chess/shared';

const MAP: Record<ModeratorText, string> = {
  no_such_piece: 'That piece no longer exists.',
  no_legal_moves: 'That piece has no legal moves.',
  wont_help: 'Moving that piece will not help you.',
  illegal_move: 'Illegal move.',
  white_moved: 'White has moved.',
  black_moved: 'Black has moved.',
  white_moved_captured: 'White has moved and captured.',
  black_moved_captured: 'Black has moved and captured.',
  white_moved_captured_ep: 'White has captured en passant.',
  black_moved_captured_ep: 'Black has captured en passant.',
  white_castled_kingside: 'White has castled kingside.',
  white_castled_queenside: 'White has castled queenside.',
  black_castled_kingside: 'Black has castled kingside.',
  black_castled_queenside: 'Black has castled queenside.',
  white_in_check: 'White is in check.',
  black_in_check: 'Black is in check.',
  white_promoted: 'White has promoted.',
  black_promoted: 'Black has promoted.',
  white_checkmate: 'Checkmate. White wins.',
  black_checkmate: 'Checkmate. Black wins.',
  stalemate: 'Stalemate. The game is a draw.',
  draw_insufficient: 'Draw — insufficient material.',
  draw_fifty: 'Draw — fifty-move rule.',
  draw_threefold: 'Draw — threefold repetition.',
  white_resigned: 'White has resigned.',
  black_resigned: 'Black has resigned.',
  draw_agreed: 'The game is a draw by agreement.',
  game_abandoned: 'The game has been abandoned.',
};

export function moderatorText(
  text: ModeratorText,
  payload?: { promotedTo?: 'q' | 'r' | 'b' | 'n' | 'p' | 'k' },
): string {
  const base = MAP[text];
  if ((text === 'white_promoted' || text === 'black_promoted') && payload?.promotedTo) {
    const piece = { q: 'queen', r: 'rook', b: 'bishop', n: 'knight', p: 'pawn', k: 'king' }[payload.promotedTo];
    return base.replace('promoted.', `promoted to a ${piece}.`);
  }
  return base;
}
